"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PromoPanel_1 = require("./PromoPanel");
exports.default = PromoPanel_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PromoPanel/index.js
// module id = 285
// module chunks = 8